<script setup>
import { WdsIllustration } from '@wds/components';

defineProps({
  tag: {
    type: String,
    required: false,
    default: 'section',
  },
  description: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <component :is="tag">
    <div class="hostelworld-says-wrapper">
      <WdsIllustration
        class="hw-says-icon"
        asset="speech"
        folder="md"
        loading="lazy"
      />
      <h2 class="hw-says-title">
        {{ $t('t_HOSTELWORLDSAYS') }}
      </h2>
      <p class="hw-says-description">
        {{ description }}
      </p>
    </div>
  </component>
</template>

<style scoped lang="scss">
.hostelworld-says-wrapper {
  display: grid;
  grid-template-areas:
    'icon'
    'title'
    'description';
  gap: $wds-spacing-xs;
  background: $wds-color-blue-lightest;
  border-radius: $wds-border-radius-xl;
  padding: $wds-spacing-m $wds-spacing-l;

  .hw-says-icon {
    grid-area: icon;
  }

  .hw-says-title {
    grid-area: title;
    margin-bottom: $wds-spacing-xs;
  }

  .hw-says-description {
    grid-area: description;
  }

  @include desktop {
    grid-template-areas:
      'icon title'
      'icon description';
    gap: $wds-spacing-xs $wds-spacing-l;
    padding: wds-rem(56px);
  }

  /*
  .hw-says-title {
    @include title-4-bld;
  }
  */

  /*
  .hw-says-content {
    display: flex;
    flex-direction: column;
    padding: $wds-spacing-m $wds-spacing-l;
  }

  .hw-says-speech-icon {
    margin-top: -1rem;
    margin-right: 1rem;
  }

  .hw-says-icon {
    height: $wds-spacing-xxl;
    width: $wds-spacing-xxl;
  }

  .hw-says-description {
    padding-top: wds-rem(10px);
  }
  */

  /*
  @media screen and (width >= 600px) {
    .hw-says-description {
      padding: $wds-spacing-l;
      text-align: justify;
    }

    .hw-says-content {
      padding: $wds-spacing-xxl 3rem;
    }
  }

  @include tablet-large {
    clip-path: polygon(0 0, 100% $wds-spacing-l, 100% calc(100% - #{$wds-spacing-l}), 0 100%);

    .hw-says-description {
      padding-top: $wds-spacing-m;
    }
  }

  @include desktop {
    .hw-says-content {
      align-items: flex-start;
      flex-direction: row;
      padding: $wds-spacing-xxxl;
    }

    .hw-says-icon {
      margin-right: $wds-spacing-m;
      margin-top: -$wds-spacing-m;
    }
  }

  @include desktop-large {
    .hw-says-content {
      padding: $wds-spacing-xxxl $wds-spacing-l wds-rem(80px);
    }
  }

  @media screen and (width >= 1600px) {
    .hw-says-content {
      max-width: wds-rem(1600px);
      padding-right: wds-rem(456px) + 3rem;
      margin: auto;
    }
  }
  */
}
</style>
